/**
 * SelectionPanels.jsx — the two ways of adding ETFs, stacked.
 *
 * Phase 5 follow-up: the 50/50 split treated a quick input field and a data
 * exploration surface as equals. The paste area is now a compact block on top
 * (it no longer stretches to match the catalogue) and the catalogue owns the
 * full width below it, where it can show its columns and many more rows.
 *
 * Selection limit (`MAX_SELECTED_ETFS`) stays owned by the parent (App.js) and
 * is propagated via `selectionLimitReached` / `onLimitHit`.
 */
import { ClipboardList, Database } from "lucide-react";

import { PasteIsinArea } from "./PasteIsinArea";
import { KnownEtfTable } from "./KnownEtfTable";


export function SelectionPanels({
  // ISIN paste
  onPasteSubmit,
  pasteBusy,
  // DB selection
  knownEtfs,
  selectedEtfs,
  setSelectedEtfs,
  // Selection cap (owned by parent so paste + DB share the same bucket)
  selectionLimitReached = false,
  onLimitHit,
  disabled = false,
}) {
  return (
    <div data-testid="selection-panels" className="space-y-4">
      {/* ----------- Quick input: paste by ISIN ----------- */}
      <section
        data-testid="selection-panel-paste"
        className="workspace-card p-4 sm:p-5"
      >
        <header className="mb-2 flex flex-wrap items-baseline gap-x-2 gap-y-1">
          <div className="flex items-center gap-2">
            <ClipboardList className="h-4 w-4 text-content-muted" aria-hidden="true" />
            <h3 className="text-sm font-semibold text-content">Incolla gli ISIN</h3>
          </div>
          <p className="text-xs text-content-muted">
            Hai già la lista: incollala e la importiamo noi.
          </p>
        </header>
        <PasteIsinArea
          onSubmit={onPasteSubmit}
          uploading={pasteBusy}
          disabled={disabled}
        />
      </section>

      {/* ----------- Main surface: the catalogue ----------- */}
      <section
        data-testid="selection-panel-db"
        className="workspace-card p-4 sm:p-5 flex flex-col"
      >
        <header className="mb-3 flex flex-wrap items-baseline gap-x-2 gap-y-1">
          <div className="flex items-center gap-2">
            <Database className="h-4 w-4 text-content-muted" aria-hidden="true" />
            <h3 className="text-sm font-semibold text-content">Scegli dal catalogo</h3>
          </div>
          <p className="text-xs text-content-muted">
            Cerca fra gli ETF già disponibili e spuntali.
          </p>
        </header>
        <KnownEtfTable
          knownEtfs={knownEtfs}
          selectedEtfs={selectedEtfs}
          setSelectedEtfs={setSelectedEtfs}
          selectionLimitReached={selectionLimitReached}
          onLimitHit={onLimitHit}
          disabled={disabled}
        />
      </section>
    </div>
  );
}

export default SelectionPanels;
